import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    width: "7",
    height: "7",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
        _createElementVNode("path", {
            class: _normalizeClass(["indicator", [$props.color]]),
            d: "M 21.961621,11 C 21.961621,17.056769 17.053947,21.966731 11,21.966731 4.9460531,21.966731 0.03837869,17.056769 0.03837869,11 0.03837869,4.9432309 4.9460531,0.03326902 11,0.03326902 17.053947,0.03326902 21.961621,4.9432309 21.961621,11 Z",
            fill: "#6f6f6f"
        }, null, 2)
    ]));
}
